import React from 'react'
import styled from '@emotion/styled'
import { Form, color } from 'stylist'
import { PrimaryButton } from 'components/Button'
import Tooltip from 'components/Tooltip'
import { isQuestionsValid } from 'utils/form'

const NoProvidersButton = styled(PrimaryButton)`
  &,
  &:hover:not([disabled]),
  &:focus {
    background-color: ${color('red')};
    cursor: not-allowed;
  }
`

const GetPrices = ({ disabled, noProviders, ...props }) => (
  <Form.Field
    name="questions"
    render={({ value }) =>
      noProviders ? (
        <Tooltip
          id="no-results-tooltip"
          contents="Please edit the bid details or reach out to your FocusVision representative."
        >
          <NoProvidersButton {...props} type="button">
            No Results
          </NoProvidersButton>
        </Tooltip>
      ) : (
        <PrimaryButton
          type="submit"
          disabled={disabled || !isQuestionsValid(value)}
          {...props}
        >
          Get Prices
        </PrimaryButton>
      )
    }
  />
)

export default GetPrices



// WEBPACK FOOTER //
// ./src/routes/estimate/subroutes/form/GetPrices.js